<template>
    <div :class="[ totalPage === 1 ? 'mb-5 blog-list item' : 'blog-list item']" v-if="blogs">
        <div class="blog-card" v-for="blog in blogs" :key="blog.id" @click="showDetail(blog.id)">
            <section class="img">
                <img class="img-card" :src="blog.post_image_url" alt="">
            </section>
            <section class="content">
                <div class="title-card">{{ blog.post_title }}</div>
                <div class="description-crad">
                    <p>{{ removeHTMLTags(blog.post_content) }}</p>
                </div>
                <div class="detail-crad">
                    <div class="created-by">By BeNeat</div>
                    <div><i class="time"></i>{{ blog.updated_at | prettyOnlyDateBE}}</div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
      props: {
        queryDataPage: Number,
        queryDataLimit: Number,
        showInPageConent: Boolean,
        blogId: Number
      },
      data () {
        return {
          blogs: [],
          loading: false,
          totalPage: 0,
          queryData: {
            page: 0,
            limit: 0
          }
        }
      },
      watch: {
        '$route.params.id': {
          handler: function (id) {
            // console.log('id', id)
            this.getBlogsData(0, id)
          },
          deep: true,
          immediate: true
        }
      },
      methods: {
        async getBlogsData (queryPage, blogId) {
          try {
            this.$swal.showLoading()
            this.queryData = {
              page: queryPage,
              limit: this.queryDataLimit
            }
            const {data} = await axios.get('/blog', { params: this.queryData })
            this.$swal.close()
            if (data.error) {
              this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
              return
            }
            let filtered = data.blogs.filter(function (item) {
              return item.id !== Number(blogId)
            })
            // console.log('filtered', filtered, Number(blogId))
            this.blogs = filtered
            this.totalPage = data.page_count
            this.$emit('visiblePageNumber', this.totalPage)
          } catch (e) {
            this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          }
        },
        showErrorMessage (message) {
          this.$swal({
            text: message,
            type: 'error',
            confirmButtonColor: '#2C94BB',
            confirmButtonText: 'ปิด'
          })
        },
        removeHTMLTags (htmlString) {
          // Create a new DOMParser instance
          const parser = new DOMParser()
          // Parse the HTML string into a DOM document
          const doc = parser.parseFromString(htmlString, 'text/html')
          // Extract the text content from the parsed document
          const textContent = doc.body.textContent || ''
          return textContent.trim() // Trim any leading or trailing whitespace
        },
        showDetail (blogId) {
          // console.log('blogId', blogId)
          this.$router.push(`/blog/${blogId}`)
        }
      },
      created () {
        this.getBlogsData(0, this.blogId) // defult query page 0
      }
    }
</script>
<style scoped lang="scss">
.blog-list {
  margin-top: 24px;
  column-gap: 24px;
  row-gap: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
.blog-card {
    width: 100%;
    height: auto;
}
.blog-card:hover {
    width: 100%;
    height: auto;
    cursor: pointer;
    .title-card{
        font-size: 18px;
        font-weight: 600;
        color: #00B4CD;
    }
    .img-card {
        width: 100%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
}
.description-crad p{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    margin-top: 14px;
}
.title-card {
    font-size: 18px !important;
    font-weight: 600;
}
.detail-crad {
    display: flex;
    column-gap: 40px;
    align-items: center;
    color: #7F7F7F;
}
.time {
    background: url('/static/img/Vector.png');
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    margin-left: -27px;
    margin-top: 2px;
}
.detail-crad .created-by {
    font-size: 14px;
    font-weight: 400;
    color: #4D4D4D;
}
.img-card {
    width: 100%;
}
.content {
    margin-top: 24px;
}
@media (max-width: 450px) {
  .blog-list {
    grid-template-columns: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blogs/components/Blogs.vue